const switchStyle = ((theme) => ({
  default: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '20px',
    width: 'auto',
    padding: '2px 0 2px 10px',
  },
  enabled: {
    color: theme.palette.primary.text,
    backgroundColor: theme.palette.primary.lighter,
  },
  disabled: {
    color: theme.palette.grey[500],
    backgroundColor: theme.palette.grey[200],
  },
}));

export default switchStyle;
